import { motion } from 'framer-motion'
import styled, { css } from 'styled-components/macro'

import { styleReset } from 'styles/misc'
import { mq } from 'styles/mq'
import { theme } from 'styles/theme'

export const ArticleLayout = styled(motion.div)`
  padding-top: calc(
    var(--container-spacing) / 2 + var(--timeline-height) + var(--header-height)
  );

  ${mq.medium} {
    display: grid;
    grid-template-columns: 20rem 1fr;
    max-width: 80rem;
    margin: 0 auto;
    gap: 0 3rem;
  }

  ${mq.large} {
    grid-template-columns: 20rem 55rem 1fr;
    max-width: none;
    margin: 0;
  }

  p {
    font-size: 2rem;
  }

  p:last-child {
    margin-bottom: 0;
  }

  // this was the only way for me to add styles to figure. Olga
  figure {
    margin: 3rem 0;
  }
  figure img {
    width: calc(100% + var(--container-spacing) * 2);
    margin-left: calc(var(--container-spacing) * -1);
  }
  ${mq.medium} {
    figure {
      display: flex;
      align-items: center;
    }

    figcaption {
      padding-left: 2rem;
      font-size: 1.8rem;
      color: ${theme.colors.accent.secondary};
    }
    figure img {
      width: auto;
      margin: 0;
      max-width: 320px;
    }
  }
`

export const MainContent = styled.div`
  position: relative;

  ${mq.medium} {
    grid-column: 2;
  }

  h2 {
    margin-bottom: 0.9rem;
    margin-top: 3rem;
  }
`

export const Person = styled.span`
  ${styleReset}
  display: inline-block;
  font-size: 1.8rem;
  font-weight: bold;

  ${mq.large} {
    display: block;
    position: absolute;
    right: 100%;
    width: max-content;
    max-width: 25rem;
    margin: 1.8rem 3rem 1.8rem 0;
    text-align: right;
    font-size: 2rem;
    line-height: 2rem;
    color: ${theme.colors.accent.secondary};

    p + &,
    figure + & {
      margin-top: 0;
    }

    h2 + & {
      margin-top: 1.3rem;
    }
  }
`

export const PersonButton = styled(Person).attrs({ as: 'button' })`
  padding: 0.1em 0.3em 0;
  color: white;
  cursor: pointer;
  background-color: ${theme.colors.accent.primary};

  ${mq.ltLarge} {
    margin-top: 0.5em;
  }

  &::before {
    content: '';
    display: inline-block;
    vertical-align: baseline;
    width: 0.9em;
    height: 0.9em;
    margin: 0 0.1em -0.14em 0;
    background-color: currentColor;
    mask-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 19 19' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3.96191 16.0889H2.46191V15.3389C2.46522 12.4407 4.81379 10.0922 7.71191 10.0889H10.7119C13.61 10.0922 15.9586 12.4407 15.9619 15.3389V16.0889H14.4619H13.7119C11.7442 16.0889 12.782 16.0913 10.7119 16.0889H7.71191C7.3151 16.0893 7.10121 16.0896 6.99445 16.0898C6.92734 16.09 6.82335 16.0901 6.99445 16.0898C7.10391 16.0895 7.11521 16.0889 5.67406 16.0889H3.96191Z' fill='currentColor'/%3E%3Cpath d='M5.46191 5.58887C5.46191 7.65993 7.14085 9.33887 9.21191 9.33887C11.282 9.33639 12.9594 7.65891 12.9619 5.58887C12.9619 3.5178 11.283 1.83887 9.21191 1.83887C7.14085 1.83887 5.46191 3.5178 5.46191 5.58887Z' fill='currentColor'/%3E%3C/svg%3E%0A");
  }

  ${mq.large} {
    padding: 0;
    text-decoration: underline 2px solid ${theme.colors.accent.primary};
    color: ${theme.colors.accent.secondary};
    background-color: transparent;

    &:hover,
    &:focus-visible {
      color: ${theme.colors.accent.primary};
    }
  }
`

export const Section = styled(ArticleLayout).attrs({ as: 'section' })`
  padding-top: 0;

  ${mq.medium} {
    grid-column: 1 / 4;

    > :first-child:not(${MainContent}) {
      text-align: right;
    }
  }
`

export const RadioImg = styled.img<{ isPeopleListOpen: boolean }>`
  display: none;
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100vmin;
  transform: translate(20rem, -45%);
  transition: transform 0.4s;

  ${mq.large} {
    display: block;
  }

  ${props =>
    props.isPeopleListOpen &&
    css`
      transform: translate(22rem, -45%);
      transition-delay: 0.2s;
    `}
`
